/* WWD Collections Index v5 — SEO/GEO Optimized + Grouped Layout */
(function(){
  "use strict";
  var types={"adc-analog-to-digital-converters":"category","advanced-micro-devices":"manufacturer","amd-xilinx":"manufacturer","amplifiers":"category","analog-devices":"manufacturer","analog-devices-maxim-integrated":"manufacturer","analog-switches-multiplexers":"category","arria-10-sx-devices":"series","arria-ii-gx-fpga":"series","arria-v-gx-fpga":"series","arria-v-sx-soc":"series","artix-7-fpga":"series","certuspro-nx-family":"series","clock-timing":"category","clock-timing-ics":"category","comparators":"category","cortex-m1-flash-family-fpgas":"series","cpld":"category","crosslink-nx-family":"series","cyclone-ii-fpga":"series","cyclone-iii-fpga":"series","cyclone-iv-fpga":"series","cyclone-v-fpga":"series","cypress-semiconductor-infineon":"manufacturer","dac-digital-to-analog-converters":"category","data-acquisition":"category","dsp-digital-signal-processors":"category","embedded-processors-fpgas":"category","festo-corporation":"manufacturer","flex-6000-devices":"series","fpga":"category","freescale-nxp":"manufacturer","harris-corporation":"manufacturer","high-performance-cpld":"series","ice40-ultraplus-family":"series","igloo-nano-low-power-flash-fpgas":"series","igloo2-fpga-smartfusion2":"series","industrial-automation-controls":"category","industrial-sensors":"category","infineon":"manufacturer","integrated-circuits-ics":"category","intel-altera":"manufacturer","interface-ics":"category","interface-ics-1":"category","intersil-renesas":"manufacturer","ispmach-4a-cpld-family":"series","kintex-ultrascale-fpga":"series","kintex-7-fpga":"category","lattice-semiconductor":"manufacturer","latticeecp-ec-family":"series","latticeecp2-m-family":"series","latticexp2-family":"series","linear-ics":"category","logic-ics":"category","logic-ics-1":"category","mach-5-cpld-family":"series","machxo-family":"series","machxo2-family":"series","machxo3-family":"series","max-10-fpga":"series","max-ii-cpld":"series","max-v-cpld":"series","memory":"category","memory-buffers-registers":"category","memory-ics":"category","microchip-technology":"manufacturer","microcontrollers":"category","micron-technology":"manufacturer","microprocessors":"category","microsemi-microchip":"manufacturer","motorola":"manufacturer","national-semiconductor-ti":"manufacturer","nxp-semiconductors":"manufacturer","onsemi":"manufacturer","panel-meters":"category","pld-programmable-logic-devices":"category","pneumatics-hydraulics":"category","polarfire-fpgas":"series","polarfire-soc":"series","power-management-ic-pmic":"category","power-management-ics":"category","preparation-treatment":"category","proasic3-flash-family-fpgas":"series","renesas-electronics":"manufacturer","rf-wireless":"category","rf-wireless-ics":"category","rf-directional-couplers":"category","rf-ics-modules":"category","rochester-electronics":"manufacturer","sensors":"category","smartfusion2-soc":"series","spartan-3-fpga":"series","spartan-3an-fpga":"series","spartan-3e-fpga":"series","spartan-6-fpgas":"series","specialized-ics":"category","specialized-ics-1":"category","stmicroelectronics":"category","stratix-iii-fpga":"series","stratix-iv-fpga":"series","stratix-v-fpga":"series","system-on-chip-soc":"category","te-connectivity":"manufacturer","texas-instruments":"manufacturer","torex-semiconductor":"manufacturer","virtex-ultrascale-fpga":"series","virtex-4-fpga":"series","virtex-5-fpga":"series","virtex-6-fpga":"series","virtex-7-fpga":"series","voltage-references":"category","voltage-regulators":"category","xc4000x-fpga-family":"series","zynq-ultrascale-mpsoc":"series","zynq-ultrascale-rfsoc":"series","zynq-7000-soc":"series","ecp5-fpgas":"series","machxo2-3-fpgas":"series","connectors":"category","passive-components":"category"};

  var labels={
    manufacturer:{
      title:"Authorized Semiconductor Manufacturers",
      desc:"Authorized distributor for AMD/Xilinx, Intel/Altera, Lattice, Microchip, TI, ADI, NXP, and more. Genuine components with COC documentation and AS6081 inspection.",
      icon:'<svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M3 21h18M3 7v14M21 7v14M6 11h2M6 15h2M10 11h2M10 15h2M14 11h2M14 15h2M18 11h2M18 15h2M8 7V3h8v4"/></svg>'
    },
    series:{
      title:"FPGA & SoC Product Series",
      desc:"Spartan, Artix, Kintex, Virtex, Zynq, Cyclone, PolarFire, MachXO — including hard-to-find, EOL, and allocated FPGA/SoC parts with verified stock and competitive pricing.",
      icon:'<svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="2"/><path d="M9 1v3M15 1v3M9 20v3M15 20v3M1 9h3M1 15h3M20 9h3M20 15h3"/></svg>'
    },
    category:{
      title:"Electronic Component Categories",
      desc:"ICs, FPGAs, CPLDs, power management, sensors, memory, and more. Filter by specification, package type, or application to find the right part.",
      icon:'<svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>'
    }
  };

  function ready(fn){
    if(document.readyState!=="loading") fn();
    else document.addEventListener("DOMContentLoaded",fn);
  }

  ready(function(){
    var main=document.querySelector(".main-collection");
    if(!main) return;

    /* === 1. Quick Entry Pills === */
    var pageTitle=main.querySelector(".page-header");
    if(pageTitle){
      pageTitle.textContent="Semiconductor Components & FPGA Sourcing";
      var pills=document.createElement("div");
      pills.className="wwd-pills-bar";
      [{text:"FPGA",href:"/collections/fpga"},{text:"CPLD",href:"/collections/cpld"},{text:"SoC",href:"/collections/system-on-chip-soc"},{text:"Power ICs",href:"/collections/power-management-ics"},{text:"AMD / Xilinx",href:"/collections/amd-xilinx"},{text:"Intel / Altera",href:"/collections/intel-altera"},{text:"Lattice",href:"/collections/lattice-semiconductor"},{text:"Request Quote",href:"/pages/rfq",cls:"wwd-pill-rfq"}
      ].forEach(function(e){
        var a=document.createElement("a");a.href=e.href;a.className="wwd-pill"+(e.cls?" "+e.cls:"");a.textContent=e.text;
        pills.appendChild(a);
      });
      pageTitle.parentNode.insertBefore(pills,pageTitle.nextSibling);
    }

    /* === 2. Type filter tabs === */
    var tabBar=document.createElement("div");
    tabBar.className="wwd-type-tabs";
    var countLabel=document.createElement("span");
    countLabel.className="wwd-filter-count";

    [{id:"all",label:"All"},{id:"grouped",label:"Grouped"},{id:"category",label:"Categories"},{id:"manufacturer",label:"Manufacturers"},{id:"series",label:"FPGA Series"}
    ].forEach(function(t){
      var btn=document.createElement("button");
      btn.className="wwd-tab"+(t.id==="grouped"?" wwd-tab--active":"");
      btn.dataset.type=t.id;
      btn.textContent=t.label;
      btn.addEventListener("click",function(){
        tabBar.querySelectorAll(".wwd-tab").forEach(function(b){b.classList.remove("wwd-tab--active")});
        btn.classList.add("wwd-tab--active");
        if(t.id==="grouped") showGrouped();
        else filterCards(t.id);
      });
      tabBar.appendChild(btn);
    });

    var pillsBar=main.querySelector(".wwd-pills-bar");
    if(pillsBar){
      pillsBar.parentNode.insertBefore(tabBar,pillsBar.nextSibling);
      pillsBar.parentNode.insertBefore(countLabel,tabBar.nextSibling);
    }

    /* === 3. Tag each card + get grid === */
    var cards=main.querySelectorAll(".collection-list-item");
    var grid=cards.length>0?cards[0].parentElement:null;

    cards.forEach(function(card){
      var link=card.querySelector(".collection-title a");
      if(!link) return;
      var handle=(link.getAttribute("href")||"").replace("/collections/","").split("?")[0];
      card.dataset.hubType=types[handle]||"unknown";
    });

    /* === 4. Grouped view (default) === */
    function showGrouped(){
      if(!grid) return;
      grid.querySelectorAll(".wwd-group-header").forEach(function(h){h.remove()});
      var order=["manufacturer","category","series"];
      var sorted=Array.from(cards).sort(function(a,b){
        var ia=order.indexOf(a.dataset.hubType);
        var ib=order.indexOf(b.dataset.hubType);
        if(ia===-1) ia=99; if(ib===-1) ib=99;
        if(ia!==ib) return ia-ib;
        var ta=(a.querySelector(".collection-title a")||{}).textContent||"";
        var tb=(b.querySelector(".collection-title a")||{}).textContent||"";
        return ta.localeCompare(tb);
      });
      var lastType="";
      var count=0;
      sorted.forEach(function(card){
        var t=card.dataset.hubType;
        if(t!==lastType && labels[t]){
          var header=document.createElement("div");
          header.className="wwd-group-header";
          header.innerHTML='<div class="wwd-group-icon">'+labels[t].icon+'</div><div><h2 class="wwd-group-title">'+labels[t].title+'</h2><p class="wwd-group-desc">'+labels[t].desc+'</p></div>';
          grid.appendChild(header);
          lastType=t;
        }
        card.style.display="";
        grid.appendChild(card);
        count++;
      });
      countLabel.textContent=count+" collection"+(count!==1?"s":"");
    }

    /* === 5. Filter view === */
    function filterCards(type){
      grid.querySelectorAll(".wwd-group-header").forEach(function(h){h.remove()});
      var count=0;
      cards.forEach(function(card){
        if(type==="all"){card.style.display="";count++;}
        else{var show=card.dataset.hubType===type;card.style.display=show?"":"none";if(show) count++;}
      });
      countLabel.textContent=count+" collection"+(count!==1?"s":"");
    }

    /* === 6. Default to grouped view === */
    showGrouped();

    /* === 7. Make cards clickable === */
    main.querySelectorAll(".banner-item").forEach(function(card){
      var link=card.querySelector(".collection-title a");
      if(!link) return;
      card.addEventListener("click",function(e){
        if(e.target.tagName==="A") return;
        window.location.href=link.getAttribute("href");
      });
    });

    /* === 8. Placeholder for missing images === */
    var svg='<svg viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.3)" stroke-width="1.5"><rect x="4" y="4" width="16" height="16" rx="2"/><path d="M9 1v3M15 1v3M9 20v3M15 20v3M1 9h3M1 15h3M20 9h3M20 15h3"/></svg>';
    main.querySelectorAll(".banner-item .img-box img").forEach(function(img){
      if(!img.getAttribute("src")&&!img.getAttribute("data-srcset")){
        var p=document.createElement("div");p.className="wwd-placeholder-bg";p.innerHTML=svg;
        img.parentNode.replaceChild(p,img);
      }
    });
  });
})();
